export default __webpack_public_path__ + "static/media/driversIcon.a4461116.svg";